import React, { CSSProperties, FunctionComponent, useCallback } from 'react';
import classNames from 'classnames';
import { DivButton } from '../root/components/DivButton';
import styles from './SlideToggle.module.scss';

export interface SlideOption {
  label: string;
  value: string | number;
  onClickCallback?: () => void;
}

interface SlideToggleProps {
  option1: SlideOption;
  option2: SlideOption;
  selectedOption: string;
  style?: CSSProperties;
}

export const SlideToggle: FunctionComponent<SlideToggleProps> = ({ selectedOption, option1, option2, style }) => {
  const isSelected = useCallback((option: SlideOption) => selectedOption === option.value, [selectedOption]);
  const bgMarginLeft = isSelected(option1) ? 0 : 'calc(50% - 5px)';

  return (
    <div className={styles.slideToggleWrapper} style={style}>
      <div className={styles.slideToggle}>
        <div className={styles.slideToggleBackground} style={{ marginLeft: `${bgMarginLeft}` }} />
        <DivButton
          disabled={isSelected(option1)}
          onClick={() => {
            option1.onClickCallback?.();
          }}
          className={classNames({ [styles.hlOptionSelected]: isSelected(option1) })}
          label={`Select: ${option1.label}`}
        >
          {option1.label}
        </DivButton>
        <DivButton
          disabled={isSelected(option2)}
          onClick={() => {
            option2.onClickCallback?.();
          }}
          className={classNames({ [styles.hlOptionSelected]: isSelected(option2) })}
          label={`Select: ${option2.label}`}
        >
          {option2.label}
        </DivButton>
      </div>
    </div>
  );
};
